<template>
  <div class="card editable-card">
    <div style="display: flex;">
      <div class="links-body">
        <div class="statBlock">
          <div class="card-header" v-if="$slots.header">
            <slot name="header"></slot>
          </div>
          <div class="card-body">
            <div class="inputs row">
              <div class="col-lg">
                <div class="inv_edit_label_row">
                  <!--<div class="inv_edit_label">My Ownership:</div><input class="url-form-field" />-->
                  <div>My Ownership (0-100%)</div>
                  <input
                    class="url-form-field"
                    type="number"
                    placeholder="Your ownership"
                    min="0"
                    max="100"
                    v-model="localPortfolio.ownership"
                  />
                </div>
              </div>
              <div class="col-lg">
                <div class="inv_edit_label_row">
                  <!--<div class="inv_edit_label">My Cost:</div><input class="url-form-field" />-->
                  <div>My Cost:</div>
                  <input
                    class="url-form-field"
                    type="number"
                    placeholder="Your cost"
                    v-model="localPortfolio.cost"
                  />
                </div>
              </div>
              <div class="col-lg">
                <div class="inv_edit_label_row">
                  <!--<div class="inv_edit_label">Current value:</div><input class="url-form-field" />-->
                  <div>Current Value:</div>
                  <input
                    class="url-form-field"
                    type="number"
                    placeholder="Your value"
                    v-model="localPortfolio.value"
                  />
                </div>
              </div>
            </div>
            <div class="inputs row">
              <!--<div class="inv_edit_label_row"><div class="inv_edit_label">Multiple:</div><input class="url-form-field" /></div>-->
              <!--<div class="inv_edit_label_row"><div class="inv_edit_label">Gain/Loss:</div><input class="url-form-field" /></div>-->
              <div class="col-lg">
                <!--<div class="inv_edit_label_row"><div class="inv_edit_label">Initial Investment:</div><input class="url-form-field" /></div>-->
                <div>Initial Investment</div>
                <input
                  class="url-form-field"
                  type="date"
                  :value="localPortfolio.initial_investment && moment.utc(localPortfolio.initial_investment).format('YYYY-MM-DD')"
                  @input="localPortfolio.initial_investment = moment($event.target.valueAsDate)"
                />
              </div>
              <div class="col-lg">
                <!--<div class="inv_edit_label_row"><div class="inv_edit_label">Initial Investment:</div><input class="url-form-field" /></div>-->
                <div>Last Funding Round</div>
                <input
                  class="url-form-field"
                  type="date"
                  :value="localPortfolio.last_funding && moment.utc(localPortfolio.last_funding).format('YYYY-MM-DD')"
                  @input="localPortfolio.last_funding = moment($event.target.valueAsDate)"
                />
              </div>
            </div>
            <div class="inputs row">
              <div class="col-md-6">
                <div class="inv_edit_label_row">
                  <div>Direct/LP:</div>
                  <el-select
                    class=""
                    size="large"
                    placeholder="Select Status"
                    v-model="localPortfolio.direct"
                  >
                    <el-option
                      v-for="option in vals.PORTFOLIO.DIRECT_LP"
                      class=""
                      :value="option"
                      :label="option"
                      :key="option"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="actionbuttons">
              <button @click="cancel" class="btn btn-info btn-fill btn-wd">Cancel</button>
              <button @click="save" class="btn btn-info btn-fill btn-wd">Save</button>
            </div>
          </div>
          <!--<a href="#" class="edit-button">Edit</a>-->
          <div class="card-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "../Card.vue";
import moment from "moment";
import { vals } from "../../../util";
import { Dialog, Select, Option } from "element-ui";

export default {
  name: "edit-investment-info-card",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    Card
  },
  computed: {
    moment() {
      return moment;
    },
    vals() {
      return vals;
    }
  },
  props: ["context", "portfolio"],
  data() {
    return {
      localPortfolio: _.assign({}, this.portfolio)
    };
  },
  methods: {
    cancel() {
      this.$emit("edit-investment-info-card-close", this.context, { confirm: false });
    },
    save() {
      this.$emit("edit-investment-info-card-close", this.context, { confirm: true, data: this.localPortfolio });
    }
  },
  watch: {
    portfolio(newPortfolio) {
      this.localPortfolio = _.assign({}, newPortfolio);
    }
  }
};
</script>
<style>
.editable-card {
  height: calc(100% - 30px);
}

.links-body {
  width: 100% !important;
}

.edit-company-card-dialog .select-primary {
  margin-right: 10px;
}

.select-box {
  margin-bottom: 10px;
}

.edit-logo-box {
  margin-bottom: 10px;
  margin-left: 10px;
}

.edit-logo-box div {
  margin-bottom: 5px;
}

.select-box div {
  margin-bottom: 5px;
}

.url-form-field {
  border: 1px solid #707070;
  border-radius: 3px;
  padding: 8px;
  height: 40px;
  width: 100%;
}

.inv_edit_label {
  width: 120px;
}

.inv_edit_label_row {
  margin: auto;
}

.url-form-field {
  border: 1px solid #707070;
  border-radius: 3px;
  padding: 8px;
  height: 40px;
}
</style>